import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "o-crea";
// Adresse canonique unique du site — utilisée pour canonical, og:url et les images.
// Jamais déduite du domaine appelant (preview, www…) : toujours le domaine de production.
const SITE_URL = "https://o-crea.ch";
const DEFAULT_TITLE = "Objets personnalisés faits maison";
const DEFAULT_DESC =
  "Objets personnalisés faits main en Suisse : gravure laser sur bois et métal, sublimation sur mugs, gourdes et sacs. Votre texte, votre image, une seule paire de mains.";
const DEFAULT_IMAGE =
  "https://lasersonly.com/cdn/shop/articles/laser_wood_engraving_process.png?v=1701371829";

const absolute = (u) => {
  if (!u) return DEFAULT_IMAGE;
  if (String(u).startsWith("http")) return u;
  return SITE_URL + u;
};

export default function SEO({ title, description, image, path, type = "website", noindex = false }) {
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — ${DEFAULT_TITLE}`;
  const desc = description || DEFAULT_DESC;
  const img = absolute(image);
  const url = SITE_URL + (path ?? window.location.pathname);

  // SPA : les balises statiques d'index.html (marquées data-static-seo dans index.js)
  // servent de valeurs par défaut pour les crawlers sans JavaScript (WhatsApp, Facebook…).
  // Dès le premier rendu React, on les supprime : Helmet devient la seule source de
  // balises og/twitter/description — aucun doublon pour les crawlers JS (Google).
  useEffect(() => {
    document.head.querySelectorAll("meta[data-static-seo]").forEach((el) => el.remove());
  }, []);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="fr_CH" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
